import { Dimensions } from 'react-native';

const window = Dimensions.get('window');

export const Design = {
  window,
};


export const MenuPositions = {
  topLeft: 'top-left',
  topRight: 'top-right',
  bottomLeft: 'bottom-left',
  bottomRight: 'bottom-right',
};
